import { cn } from '@/lib/cn'

export function UserAvatar({
  initial,
  size = 'md',
  src,
}: {
  initial: string
  size?: 'md' | 'lg'
  src?: string
}) {
  const className = cn(
    'flex shrink-0 items-center justify-center rounded-full bg-[var(--color-primary)] font-medium leading-none text-white',
    size === 'lg' ? 'size-9 text-xl font-bold' : 'size-8 text-[14px]',
  )

  if (src) {
    return (
      <img
        alt=""
        aria-hidden
        className={cn(className, 'object-cover')}
        decoding="async"
        src={src}
      />
    )
  }

  return (
    <span aria-hidden className={className}>
      {initial}
    </span>
  )
}
